import { AnalyticsField } from '@/store/analytics/utils/enums'

// Kept in a leaf module so SQL builders can import the table name without pulling in
// the value store (and, through it, the API client).
export const TABLE_NAME = 'analytics_value'

export const NEGATIVE_VALUE_POSTFIX = '-negative-value'
export const POSITIVE_VALUE_POSTFIX = '-positive-value'

export const VALUE_LIST_SEARCHABLE_TEXT = [
  AnalyticsField.ACCOUNT_ID,
  AnalyticsField.ACCOUNT_TYPE,
  AnalyticsField.ASSET_ID,
  AnalyticsField.ASSET_TYPE,
]

export const VALUE_LIST_POSIBLE_VALUES = [
  AnalyticsField.AMOUNT,
  AnalyticsField.POSITION_CLOSE,
  AnalyticsField.POSITION_COST,
  AnalyticsField.POSITION_GAIN,
]
